import { Box, Card, CardContent, Typography } from "@mui/material";
import { LitigationFunnelMatter } from "../../../api/models/LitigationFunnelMatter";
import { useState } from "react";
import { MatterDialog } from "./MatterDialog";
import AssignmentIcon from '@mui/icons-material/Assignment';
import PersonIcon from '@mui/icons-material/Person';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

interface Props {
  matter: LitigationFunnelMatter;
}

export const MatterCard = ({ matter }: Props) => {
  const [open, setOpen] = useState(false);
  
  return (
    <>
      <Card 
        onClick={() => setOpen(true)}
        sx={{
          borderRadius: 2,
          border: '1px solid #ccc',
          marginTop: 1,
          cursor: 'pointer'
        }}
      >
        <CardContent 
          sx={{padding: 1, paddingBottom: '8px !important'}}
        >
          <Typography 
            variant="subtitle2" 
            sx={{ 
              textWrap: 'auto', 
              wordWrap: 'break-word', 
              wordBreak: 'break-all', 
              fontWeight: 'bold',
              }}>
                {matter.matter.display_number}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Typography variant="caption" color="textSecondary" sx={{ textWrap: 'auto', wordBreak: 'break-all', wordWrap: 'break-word', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
              <AssignmentIcon sx={{ fontSize: '0.75rem', mr: 0.5 }} />
              {matter.task.name}
            </Typography>

            <Box sx={{ display: 'flex', justifyContent: 'space-between'}}>
              <Typography variant="caption" color="textSecondary" sx={{ textWrap: 'auto'}}>
                <PersonIcon sx={{ fontSize: '0.75rem', mr: 0.5 }} />
                {matter.task.assignee.name}
              </Typography>
              <Typography variant="caption" color="textSecondary">
                <CalendarTodayIcon sx={{ fontSize: '0.75rem', mr: 0.5 }} />
                {new Date(matter.task.due_at).toLocaleDateString('en-US')}
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </Card>
      
      { open && <MatterDialog open={open} onClose={() => setOpen(false)} matterId={matter.matter.id} /> }
    </>
  );
};
